import _ from 'lodash';
import qs from 'qs';

export default {
  methods: {
    generateLink(url, oldQuery, selectedDate) {
      const queryObj = _.assign(_.cloneDeep(oldQuery), selectedDate);
      const query = qs.stringify(queryObj, { addQueryPrefix: true, skipNulls: true });
      if (url) {
        return `${url}${query}`;
      }
      return query;
    },
    generateQuery(oldQuery, newQuery) {
      return _.assign(_.cloneDeep(oldQuery), newQuery);
    },
  },
};
